export { Pill } from './pill.component';
